import React from 'react'
import {useSharedStore} from '../../../../state/shared-store-context'
import {ToolbarNotifications} from './toolbar-notifications'

export const HeaderNotifications = ({rootElementRef, containerName}) => {
    const {sharedState} = useSharedStore()
    return <ToolbarNotifications
        rootElementRef={rootElementRef}
        containerName={containerName}
        floatingPosition={sharedState.floatingHeaderPosition}
        isHidden={sharedState.scrolledPast320 && !sharedState.noHideHeader && sharedState.headerContent}
        hasContent={sharedState.headerContent}
        floating={sharedState.floatingHeader}
    />
}
